module.exports = __webpack_public_path__ + "media/baner_sylwester.8fb13a2e.mp4";